export default "__VITE_ASSET__BH60$rAk__"